export const iconFontAwesomeWeatherTemperatureHigh = (
	<i className="fa-solid fa-temperature-high"></i>
);
